import AppointmentsScreenSingle from './AppointmentsScreenSingle';

export default AppointmentsScreenSingle;
